import { SerializeExportResult } from './serializeExportContent';

export const triggerBlobDownload = (
  fileBaseName: string,
  result: SerializeExportResult
): void => {
  const blob = new Blob([result.bytes as unknown as BlobPart], {
    type: result.mimeType,
  });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');

  anchor.href = url;
  anchor.download = `${fileBaseName}.${result.extension}`;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();

  // Browser download starts asynchronously; revoke after the click has been processed.
  window.setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 0);
};
